(function () {
    'use strict';

    angular
        .module('app.logTypes')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
            {
                state: 'logtypes',
                config: {
                    abstract: true,
                    url: '/logtypes',
                    template: '<ui-view/>',
                    settings: {
                        authMode: 1
                    },
                    resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            },
            {
                state: 'logtypes.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/logTypes/list.html?v=' + opsIncludeVersion,
                    controller: 'LogTypesListController',
                    controllerAs: 'vm',
                    title: 'Daily Log Types'
                }
            },
            {
                state: 'logtypes.details',
                config: {
                    url: '/detail/:id',
                    templateUrl: 'app/logTypes/details.html?v=' + opsIncludeVersion,
                    controller: 'LogTypeDetailController',
                    controllerAs: 'vm',
                    title: 'Daily Log Type',
                    settings: {}
                }
            },
            {
                state: 'logtypes.groupingslist',
                config: {
                    url: '/groupingslist',
                    templateUrl: 'app/logTypes/groupingsList.html?v=' + opsIncludeVersion,
                    controller: 'LogTypesGroupingsListController',
                    controllerAs: 'vm',
                    title: 'Daily Log Type Groupings'
                }
            },
            {
                state: 'logtypes.groupingsDetails',
                config: {
                    url: '/groupingsDetails',
                    templateUrl: 'app/logTypes/groupingDetails.html?v=' + opsIncludeVersion,
                    controller: 'LogTypesGroupingDetailsController',
                    controllerAs: 'vm',
                    title: 'Daily Log Type Grouping'
                }
            }

        ];
    }
})();
